import axios from 'axios'
import {AuthModel, NewUserRegistrationModel, RefreshTokenResponseModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/accounts/loggeduser`
export const LOGIN_URL = `${API_URL}/accounts/token`
export const REFRESH_TOKEN_URL = `${API_URL}/accounts/refresh-token`
export const VALIDATE_TOKEN_URL = `${API_URL}/accounts/validate-token`
export const REGISTER_URL = `${API_URL}/accounts/UserSignUp`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(emailUserName: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    emailUserName,
    password,
  })
}

export function singleSignOn(token: string) {
  return axios.post<AuthModel>(VALIDATE_TOKEN_URL, {
    token,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstName: string,
  lastName: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    firstName: firstName,
    lastName: lastName,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken() {
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}

// Server returns slim RefreshTokenResponseModel (tokens only).
// API expects the refresh token in the "token" field.
export function refreshToken(token: string) {
  return axios.post<RefreshTokenResponseModel>(REFRESH_TOKEN_URL, {
    token,
  })
}

//Registration

export function NewUserRegistration() {
  return axios.get<NewUserRegistrationModel>(REGISTER_URL)
}
